/**
 * Sant når en feil fra API-et betyr «finnes ikke, eller du har ikke tilgang».
 *
 * 404 og 403 behandles likt med vilje: backend gir 404 både for en id som ikke finnes og for
 * en ressurs i en annen organisasjon, og visningen skal ikke avsløre forskjellen.
 *
 * Sjekker axios-flagget `isAxiosError` direkte (det samme `axios.isAxiosError` gjør), så
 * funksjonen ikke er avhengig av axios-modulen.
 */
export function erIkkeFunnet(feil: unknown): boolean {
  if (typeof feil !== 'object' || feil === null) return false;
  const kandidat = feil as { isAxiosError?: unknown; response?: { status?: unknown } };
  if (kandidat.isAxiosError !== true) return false;
  const status = kandidat.response?.status;
  return status === 404 || status === 403;
}
